/**
 * Sentiment history record for a user
 * Stored in users/{userId}/sentimentHistory collection
 */
export default class SentimentHistoryInfo {
  /**
   * Batch run ID that generated this sentiment score
   */
  batchRunId: string = '';

  /**
   * Sentiment score (0-100)
   */
  sentimentScore: number = 0;

  /**
   * Date when this sentiment was recorded
   */
  date: Date = new Date();

  constructor(init?: Partial<SentimentHistoryInfo>) {
    Object.assign(this, init);
  }

  /**
   * Convert Firestore data to SentimentHistoryInfo instance
   */
  static fromFirestore(data: any): SentimentHistoryInfo {
    return new SentimentHistoryInfo({
      batchRunId: data.batchRunId || '',
      sentimentScore: data.sentimentScore || 0,
      date: data.date?.toDate ? data.date.toDate() : new Date(data.date),
    });
  }

  /**
   * Convert SentimentHistoryInfo to Firestore data
   */
  toFirestore(): any {
    return {
      batchRunId: this.batchRunId,
      sentimentScore: this.sentimentScore,
      date: this.date,
    };
  }
}
